// extracted by mini-css-extract-plugin
export default {"checks":"checks___V05mc","p_title":"p_title___uSNma","green_bg":"green_bg___zAXSi","purple_bg":"purple_bg___NJzVC","check_block":"check_block___ugaFt"};